import { ScreenProps } from "../../App";

import { useKicktippQuery } from "./queries/useKicktippQuery";
import "./styles/Kicktipp.sass";

const KicktippBonusScreen: React.FC<ScreenProps> = ({
  duration,
  christmasTime,
  isActive,
}) => {
  const data = useKicktippQuery();

  if (data.isLoading) return <div>Loading...</div>;

  if (data.isError || !data.data) return <div>Error...</div>;

  const { bonus_table } = data.data;
  const questions = bonus_table[0]
    ? bonus_table[0].answers.map((answer) => answer.question)
    : [];

  return (
    <div className="kicktippScreen">
      <div className="h1">
        <h1><span>Bundes</span> Elements-Tipp</h1>
      </div>
      <div className="h2"><h2>Bonus</h2></div>
      <div className="kicktippContainer">
        <div className="table">
          <table className="rankingTable">
            <thead>
              <tr>
                <th className="position">#</th>
                <th className="name">Name</th>
                {questions.map((question, questionIndex) => (
                  <th key={questionIndex}>{question}</th>
                ))}
                <th>Pkt.</th>
              </tr>
            </thead>
            <tbody>
              {bonus_table.map((row, index) => (
                <tr key={index} className={row.position > 0 && row.position <= 3 ? "top" : ""}>
                  <td className="position">{row.position > 0 ? row.position : ""}</td>
                  <td className="name">{row.name}</td>
                  {row.answers.map((answer, answerIndex) => (
                    <td key={answerIndex} className="prediction">
                      <span className="answerPoints">{answer.points}</span>
                    </td>
                  ))}
                  <td className="points">{row.total_points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default KicktippBonusScreen;
